(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1230],{

/***/ 90514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/out-of-office",
      function () {
        return __webpack_require__(41823);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ HashAnchor; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.contants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_TOP_MARGIN_IN_PIXELS = -50;

;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.tsx



var HashAnchor = function(param) {
    var name = param.name, _top = param.top, top = _top === void 0 ? DEFAULT_TOP_MARGIN_IN_PIXELS : _top;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: name,
        id: name,
        style: {
            position: "relative",
            top: "".concat(top, "px"),
            display: "block",
            visibility: "hidden"
        }
    });
};

;// CONCATENATED MODULE: ./components/HashAnchor/index.ts



/***/ }),

/***/ 78712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FormText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_HashAnchor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40176);
/* harmony import */ var components_shared_FormGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74993);
/* harmony import */ var components_shared_InputText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6776);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63955);







var FormText = function(param) {
    var name = param.name, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input;
    var ref, ref1;
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(), control = ref2.control, errors = ref2.formState.errors;
    var onChangeHandler = input.onChange || function() {
    // NOOP
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_FormGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, formGroup), {
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
            control: control,
            name: name,
            render: function(param) {
                var field = param.field;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HashAnchor__WEBPACK_IMPORTED_MODULE_1__/* .HashAnchor */ .v, {
                            name: "anchor_".concat(name)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_InputText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            id: name,
                            "aria-label": name,
                            type: "text",
                            variant: (errors === null || errors === void 0 ? void 0 : errors[name]) ? "error" : ""
                        }, input, field), {
                            onChange: function(e) {
                                field.onChange(e);
                                onChangeHandler(e);
                            }
                        }))
                    ]
                });
            }
        })
    }));
};


/***/ }),

/***/ 17975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ StyledFormGroupContent; },
/* harmony export */   "OQ": function() { return /* binding */ StyledFormGroupField; },
/* harmony export */   "S0": function() { return /* binding */ StyledFormGroupLabelExtra; },
/* harmony export */   "Xq": function() { return /* binding */ StyledHelpIcon; },
/* harmony export */   "Z2": function() { return /* binding */ StyledFormGroupLabelWrapper; },
/* harmony export */   "Zm": function() { return /* binding */ StyledBottomAction; },
/* harmony export */   "dS": function() { return /* binding */ StyledFormGroup; },
/* harmony export */   "fI": function() { return /* binding */ StyledFormGroupSuccess; },
/* harmony export */   "jN": function() { return /* binding */ StyledFormGroupError; },
/* harmony export */   "kI": function() { return /* binding */ StyledFormGroupLabel; },
/* harmony export */   "nX": function() { return /* binding */ StyledFormGroupSpinnerSlot; },
/* harmony export */   "qB": function() { return /* binding */ StyledHint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34956);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -",
        ";\n  left: 0;\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      gap: ",
        ";\n\n      ",
        " {\n        margin-bottom: 0;\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 0;\n      }\n\n      input {\n        flex-grow: 1;\n        width: auto;\n      }\n\n      ",
        " {\n        display: flex;\n        align-items: center;\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n\n      ",
        " {\n        width: auto;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n\n  &.muted {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      gap: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M8 10.7097C7.50116 10.7097 7.09677 11.1141 7.09677 11.6129C7.09677 12.1117 7.50116 12.5161 8 12.5161C8.49884 12.5161 8.90323 12.1117 8.90323 11.6129C8.90323 11.1141 8.49884 10.7097 8 10.7097ZM8.24742 9.93548H7.73129C7.51752 9.93548 7.34419 9.76216 7.34419 9.54839V9.5361C7.34419 7.26697 9.84226 7.48387 9.84226 6.07132C9.84226 5.42564 9.26932 4.77419 7.98935 4.77419C7.04923 4.77419 6.56145 5.08545 6.07932 5.69974C5.95326 5.86039 5.72274 5.89313 5.55519 5.77639L5.13152 5.48123C4.95006 5.35481 4.91023 5.10152 5.04619 4.92713C5.7309 4.04884 6.54329 3.48387 7.98935 3.48387C9.6771 3.48387 11.1326 4.44358 11.1326 6.07132C11.1326 8.24597 8.63452 8.13097 8.63452 9.5361V9.54839C8.63452 9.76216 8.46119 9.93548 8.24742 9.93548ZM8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0Z' fill='%2330ABD5' /%3E%3C/svg%3E\");\n  height: ",
        ";\n  width: ",
        ";\n  display: inline-block;\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  justify-content: flex-start;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var StyledFormGroupLabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupSpinnerSlot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .zindex */ .Y0)("spinnerSlot"));
var StyledBottomAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledHint = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle"));
var StyledFormGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-4"
})(_templateObject5(), function(param) {
    var inline = param.inline;
    return inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledFormGroupLabelWrapper, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledBottomAction, StyledFormGroupContent, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledSelect */ .Q);
});
var StyledFormGroupLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-5"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-6"
})(_templateObject8(), function(param) {
    var withAppend = param.withAppend;
    return withAppend && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
});
var StyledFormGroupContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-7"
})(_templateObject9());
var StyledHelpIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-8"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupLabelExtra = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-9"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_500"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupError = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-10"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("negative_500"));
var StyledFormGroupSuccess = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-11"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("positive_500"));


/***/ }),

/***/ 74993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39105);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17975);
/* harmony import */ var _HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73091);






var FormGroup = function(param) {
    var label = param.label, children = param.children, error = param.error, forId = param.forId, className = param.className, labelExtra = param.labelExtra, bottomAction = param.bottomAction, _isLabelMuted = param.isLabelMuted, isLabelMuted = _isLabelMuted === void 0 ? false : _isLabelMuted, _inline = param.inline, inline = _inline === void 0 ? false : _inline, style = param.style, success = param.success, helpContent = param.helpContent, _isLabelHidden = param.isLabelHidden, isLabelHidden = _isLabelHidden === void 0 ? false : _isLabelHidden, hint = param.hint, append = param.append, spinnerSlot = param.spinnerSlot;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__/* .useI18n */ .Q)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroup */ .dS, {
        className: className,
        style: style,
        inline: inline,
        children: [
            (label || labelExtra) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelWrapper */ .Z2, {
                className: "".concat(isLabelHidden ? "sr-only" : ""),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabel */ .kI, {
                        htmlFor: forId,
                        className: "".concat(isLabelMuted ? "muted" : "", " ").concat(isLabelHidden ? "sr-only" : ""),
                        children: label
                    }),
                    helpContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__/* .HelpTooltip */ .k, {
                        message: helpContent
                    }),
                    labelExtra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelExtra */ .S0, {
                        children: labelExtra
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupField */ .OQ, {
                withAppend: !!append,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupContent */ .Fo, {
                        children: children
                    }),
                    append
                ]
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledHint */ .qB, {
                children: hint
            }),
            bottomAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledBottomAction */ .Zm, {
                children: bottomAction
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupError */ .jN, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTimesCircle */ .nYk
                    }),
                    t(error)
                ]
            }),
            success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSuccess */ .fI, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCheckCircle */ .f8k
                    }),
                    success
                ]
            }),
            spinnerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSpinnerSlot */ .nX, {
                children: spinnerSlot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);


/***/ }),

/***/ 73091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ HelpTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17975);
/* harmony import */ var _TooltipMF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83885);



var HelpTooltip = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TooltipMF__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        content: message,
        type: "full-content",
        direction: "up",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledHelpIcon */ .Xq, {})
    });
};


/***/ }),

/***/ 56524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "iY": function() { return /* binding */ StyledInputText; },
/* harmony export */   "me": function() { return /* binding */ StyledInputTextWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  border: none;\n  appearance: none;\n  background: transparent;\n  color: ",
        ";\n  bottom: 0.8rem;\n  right: 1rem;\n  height: 1.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-right: 3rem;\n      background-image: ",
        " !important;\n      background-repeat: no-repeat;\n      background-position: right ",
        " top 50%;\n      cursor: ",
        ";\n      background-position: ",
        ";\n      padding-left: ",
        " !important;\n      padding-right: ",
        " !important;\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: ",
        ";\n      font-size: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-position: left 12px top 50%, right 12px top 47%;\n      padding-left: ",
        " !important;\n      padding-right: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-right: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  min-width: ",
        ";\n  height: 3.5rem;\n  padding: 1.25rem;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  transition: 0.3s;\n  appearance: none;\n  background-color: ",
        " !important;\n\n  &.with-specific-size {\n    width: auto;\n    min-width: auto;\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:focus {\n    transition: background-color 600000s 0s, color 600000s 0s;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n\n    ",
        "\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 4px ",
        ";\n  }\n\n  &-ms-reveral {\n    border: 1px solid transparent;\n    border-radius: 50%;\n    box-shadow: 0 0 3px surrentColor;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var roleVariants = {
    thousands: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='9' height='10' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.53816 0.0879999H1.88216V4.372H1.99416L6.37616 0.0879999H8.25216L3.46416 4.666L8.57416 10H6.61416L1.99416 5.044H1.88216V10H0.53816V0.0879999Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A\")",
        cursor: "inherit"
    },
    currency: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.048 1.692C5.864 1.556 5.636 1.456 5.364 1.392C5.1 1.32 4.804 1.284 4.476 1.284C3.956 1.284 3.504 1.444 3.12 1.764C2.744 2.076 2.468 2.556 2.292 3.204H5.604L5.4 4.008H2.148C2.132 4.144 2.12 4.284 2.112 4.428C2.104 4.572 2.1 4.724 2.1 4.884C2.1 4.988 2.1 5.088 2.1 5.184C2.1 5.28 2.104 5.372 2.112 5.46H5.016L4.812 6.24H2.184C2.288 6.912 2.496 7.416 2.808 7.752C3.128 8.088 3.588 8.256 4.188 8.256C4.524 8.256 4.812 8.192 5.052 8.064C5.3 7.928 5.512 7.756 5.688 7.548L6.276 8.136C6.068 8.416 5.776 8.656 5.4 8.856C5.024 9.048 4.604 9.144 4.14 9.144C3.284 9.144 2.608 8.9 2.112 8.412C1.616 7.916 1.292 7.192 1.14 6.24H0.276L0.504 5.46H1.056C1.048 5.364 1.044 5.268 1.044 5.172C1.044 5.068 1.044 4.96 1.044 4.848C1.044 4.552 1.056 4.272 1.08 4.008H0.288L0.54 3.204H1.224C1.336 2.724 1.496 2.308 1.704 1.956C1.912 1.596 2.16 1.3 2.448 1.068C2.736 0.828 3.052 0.651999 3.396 0.539999C3.748 0.42 4.124 0.36 4.524 0.36C4.86 0.36 5.188 0.4 5.508 0.48C5.828 0.559999 6.092 0.664 6.3 0.792L6.048 1.692Z' fill='%23389C24'/%3E%3C/svg%3E\")",
        cursor: "inherit",
        bgPosition: "right 24px top 50%",
        paddingRight: "3rem"
    },
    currencyThousands: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.048 1.692C5.864 1.556 5.636 1.456 5.364 1.392C5.1 1.32 4.804 1.284 4.476 1.284C3.956 1.284 3.504 1.444 3.12 1.764C2.744 2.076 2.468 2.556 2.292 3.204H5.604L5.4 4.008H2.148C2.132 4.144 2.12 4.284 2.112 4.428C2.104 4.572 2.1 4.724 2.1 4.884C2.1 4.988 2.1 5.088 2.1 5.184C2.1 5.28 2.104 5.372 2.112 5.46H5.016L4.812 6.24H2.184C2.288 6.912 2.496 7.416 2.808 7.752C3.128 8.088 3.588 8.256 4.188 8.256C4.524 8.256 4.812 8.192 5.052 8.064C5.3 7.928 5.512 7.756 5.688 7.548L6.276 8.136C6.068 8.416 5.776 8.656 5.4 8.856C5.024 9.048 4.604 9.144 4.14 9.144C3.284 9.144 2.608 8.9 2.112 8.412C1.616 7.916 1.292 7.192 1.14 6.24H0.276L0.504 5.46H1.056C1.048 5.364 1.044 5.268 1.044 5.172C1.044 5.068 1.044 4.96 1.044 4.848C1.044 4.552 1.056 4.272 1.08 4.008H0.288L0.54 3.204H1.224C1.336 2.724 1.496 2.308 1.704 1.956C1.912 1.596 2.16 1.3 2.448 1.068C2.736 0.828 3.052 0.651999 3.396 0.539999C3.748 0.42 4.124 0.36 4.524 0.36C4.86 0.36 5.188 0.4 5.508 0.48C5.828 0.559999 6.092 0.664 6.3 0.792L6.048 1.692Z' fill='%23389C24'/%3E%3C/svg%3E\"), url(\"data:image/svg+xml,%3Csvg width='7' height='9' viewBox='0 0 7 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0920001 0.504H1.244V4.176H1.34L5.096 0.504H6.704L2.6 4.428L6.98 9H5.3L1.34 4.752H1.244V9H0.0920001V0.504Z' fill='%23389C24'/%3E%3C/svg%3E\")",
        cursor: "inherit",
        bgPosition: "left 24px top 50%, right 24px top 47%",
        paddingLeft: "3rem"
    },
    copy: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.5 0C15.3284 0 16 0.671562 16 1.5V10.5C16 11.3284 15.3284 12 14.5 12H5.5C4.67156 12 4 11.3284 4 10.5V1.5C4 0.671562 4.67156 0 5.5 0H14.5ZM5.5 13C4.1215 13 3 11.8785 3 10.5V4H1.5C0.671562 4 0 4.67156 0 5.5V14.5C0 15.3284 0.671562 16 1.5 16H10.5C11.3284 16 12 15.3284 12 14.5V13H5.5Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A\")",
        cursor: "pointer"
    },
    error: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A\")",
        cursor: "inherit",
        borderColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_700"),
        paddingRight: "3rem"
    },
    success: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z' fill='%2378D549'/%3E%3C/svg%3E%0A\")",
        cursor: "inherit",
        paddingRight: "3rem"
    },
    loading: {
        bgImage: "url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' viewBox='0 -256 1792 1792' id='svg3025' version='1.1' inkscape:version='0.48.3.1 r9886' width='16' height='16' sodipodi:docname='spinner_font_awesome.svg'%3E%3Cmetadata id='metadata3035'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs3033' /%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='640' inkscape:window-height='480' id='namedview3031' showgrid='false' inkscape:zoom='0.13169643' inkscape:cx='896' inkscape:cy='896' inkscape:window-x='0' inkscape:window-y='25' inkscape:window-maximized='0' inkscape:current-layer='svg3025' /%3E%3Cg transform='matrix(1,0,0,-1,121.49153,1315.7966)' id='g3027'%3E%3Cpath d='M 496,192 Q 496,132 453.5,90 411,48 352,48 q -60,0 -102,42 -42,42 -42,102 0,60 42,102 42,42 102,42 59,0 101.5,-42 Q 496,252 496,192 z M 928,0 Q 928,-53 890.5,-90.5 853,-128 800,-128 747,-128 709.5,-90.5 672,-53 672,0 672,53 709.5,90.5 747,128 800,128 853,128 890.5,90.5 928,53 928,0 z M 320,640 Q 320,574 273,527 226,480 160,480 94,480 47,527 0,574 0,640 q 0,66 47,113 47,47 113,47 66,0 113,-47 47,-47 47,-113 z M 1360,192 q 0,-46 -33,-79 -33,-33 -79,-33 -46,0 -79,33 -33,33 -33,79 0,46 33,79 33,33 79,33 46,0 79,-33 33,-33 33,-79 z M 528,1088 Q 528,1015 476.5,963.5 425,912 352,912 279,912 227.5,963.5 176,1015 176,1088 q 0,73 51.5,124.5 51.5,51.5 124.5,51.5 73,0 124.5,-51.5 Q 528,1161 528,1088 z m 464,192 q 0,-80 -56,-136 -56,-56 -136,-56 -80,0 -136,56 -56,56 -56,136 0,80 56,136 56,56 136,56 80,0 136,-56 56,-56 56,-136 z m 544,-640 q 0,-40 -28,-68 -28,-28 -68,-28 -40,0 -68,28 -28,28 -28,68 0,40 28,68 28,28 68,28 40,0 68,-28 28,-28 28,-68 z m -208,448 q 0,-33 -23.5,-56.5 -23.5,-23.5 -56.5,-23.5 -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 33,0 56.5,-23.5 23.5,-23.5 23.5,-56.5 z' id='path3029' inkscape:connector-curvature='0' style='fill:%23ccc' /%3E%3C/g%3E%3C/svg%3E\")",
        cursor: "inherit",
        paddingRight: "3rem"
    },
    linkedin: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.8571 0H1.13929C0.510714 0 0 0.517857 0 1.15357V14.8464C0 15.4821 0.510714 16 1.13929 16H14.8571C15.4857 16 16 15.4821 16 14.8464V1.15357C16 0.517857 15.4857 0 14.8571 0ZM4.83571 13.7143H2.46429V6.07857H4.83929V13.7143H4.83571ZM3.65 5.03571C2.88929 5.03571 2.275 4.41786 2.275 3.66071C2.275 2.90357 2.88929 2.28571 3.65 2.28571C4.40714 2.28571 5.025 2.90357 5.025 3.66071C5.025 4.42143 4.41071 5.03571 3.65 5.03571ZM13.725 13.7143H11.3536V10C11.3536 9.11429 11.3357 7.975 10.1214 7.975C8.88571 7.975 8.69643 8.93929 8.69643 9.93571V13.7143H6.325V6.07857H8.6V7.12143H8.63214C8.95 6.52143 9.725 5.88929 10.8786 5.88929C13.2786 5.88929 13.725 7.47143 13.725 9.52857V13.7143Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A\"), linear-gradient(to right, transparent 56px, #DEDCE4 56px, #DEDCE4 58px, transparent 58px)",
        cursor: "inherit",
        paddingLeft: "5rem",
        paddingRight: "1.25rem",
        bgPosition: "left 20px top 50%, left center"
    },
    linkedinError: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.8571 0H1.13929C0.510714 0 0 0.517857 0 1.15357V14.8464C0 15.4821 0.510714 16 1.13929 16H14.8571C15.4857 16 16 15.4821 16 14.8464V1.15357C16 0.517857 15.4857 0 14.8571 0ZM4.83571 13.7143H2.46429V6.07857H4.83929V13.7143H4.83571ZM3.65 5.03571C2.88929 5.03571 2.275 4.41786 2.275 3.66071C2.275 2.90357 2.88929 2.28571 3.65 2.28571C4.40714 2.28571 5.025 2.90357 5.025 3.66071C5.025 4.42143 4.41071 5.03571 3.65 5.03571ZM13.725 13.7143H11.3536V10C11.3536 9.11429 11.3357 7.975 10.1214 7.975C8.88571 7.975 8.69643 8.93929 8.69643 9.93571V13.7143H6.325V6.07857H8.6V7.12143H8.63214C8.95 6.52143 9.725 5.88929 10.8786 5.88929C13.2786 5.88929 13.725 7.47143 13.725 9.52857V13.7143Z' fill='%23DE492B'/%3E%3C/svg%3E%0A\"), linear-gradient(to right, transparent 56px, #DE492B 56px, #DE492B 58px, transparent 58px), url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A\")",
        borderColor: "#DE492B",
        cursor: "inherit",
        paddingLeft: "5rem",
        paddingRight: "3rem",
        bgPosition: "left 20px top 50%, left center, right 20px center"
    },
    search: {
        bgImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='l6' height='16' fill='none' viewBox='0 0 512 512'%3E%3Cpath d='M504.1 471l-134-134C399.1 301.5 415.1 256.8 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c48.79 0 93.55-16.91 129-45.04l134 134C475.7 509.7 481.9 512 488 512s12.28-2.344 16.97-7.031C514.3 495.6 514.3 480.4 504.1 471zM48 208c0-88.22 71.78-160 160-160s160 71.78 160 160s-71.78 160-160 160S48 296.2 48 208z' fill='%23C0BEC9'/%3E%3C/svg%3E\")",
        cursor: "inherit",
        paddingLeft: "2.5rem",
        bgPosition: "left 12px top 50%"
    }
};
var sizeVariants = {
    sm: {
        padding: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"),
        fontSize: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"),
        height: "2.5rem"
    }
};
var StyledInputTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9e54681e-0"
})(_templateObject());
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9e54681e-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_300"));
var StyledInputText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-9e54681e-2"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl7"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), roleVariants[variant].bgImage, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), roleVariants[variant].cursor, roleVariants[variant].bgPosition, roleVariants[variant].paddingLeft, roleVariants[variant].paddingRight, roleVariants[variant].borderColor);
}, function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), sizeVariants[sizes].padding, sizeVariants[sizes].fontSize, sizeVariants[sizes].height);
}, function(param) {
    var sizes = param.sizes, variant = param.variant;
    return sizes === "sm" && variant === "currencyThousands" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
}, function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && roleVariants[variant].paddingRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), roleVariants[variant].paddingRight);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_placeholder"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"));
});


/***/ }),

/***/ 6776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _InputText_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56524);







var InputText = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var type = _param.type, variant = _param.variant, sizes = _param.sizes, style = _param.style, isPassword = _param.isPassword, onChange = _param.onChange, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "variant",
        "sizes",
        "style",
        "isPassword",
        "onChange"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isPasswordShow = _$ref[0], setIsPasswordShow = _$ref[1];
    var handleShowPasswordClick = function(e) {
        e.preventDefault();
        setIsPasswordShow(function(prev) {
            return !prev;
        });
    };
    var finalType = type || "text";
    if (isPassword) {
        finalType = isPasswordShow ? "text" : "password";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_InputText_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledInputTextWrapper */ .me, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputText_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledInputText */ .iY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                "data-lpignore": "true",
                autoComplete: "do-not-autofill",
                type: finalType,
                variant: variant,
                sizes: sizes,
                // @ts-expect-error we know
                ref: ref,
                style: style,
                onChange: onChange
            }, other)),
            isPassword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputText_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledButton */ .Sn, {
                onClick: handleShowPasswordClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: !isPasswordShow ? _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faEye */ .Mdf : _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faEyeSlash */ .Aq
                })
            })
        ]
    });
});
InputText.displayName = "InputText";
/* harmony default export */ __webpack_exports__["Z"] = (InputText);


/***/ }),

/***/ 34956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StyledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: ",
        ";\n      font-size: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 1;\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  appearance: none;\n  min-width: ",
        ";\n  height: 3.5rem;\n  padding: 1rem 3.25rem 1rem 1.25rem;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  transition: 0.3s;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23353241'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: right ",
        " top 50%;\n  background-size: 0.65em auto;\n  background-color: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 4px ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var roleVariants = {
    error: {
        borderColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_700")
    }
};
var sizeVariants = {
    sm: {
        padding: "0.25rem 0.75rem",
        fontSize: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"),
        height: "2.5rem"
    }
};
var StyledSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-8861b5b9-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), roleVariants[variant].borderColor);
}, function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), sizeVariants[sizes].padding, sizeVariants[sizes].fontSize, sizeVariants[sizes].height);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"));
});


/***/ }),

/***/ 23793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* reexport safe */ _useToasts__WEBPACK_IMPORTED_MODULE_0__.e; }
/* harmony export */ });
/* harmony import */ var _useToasts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57064);



/***/ }),

/***/ 41823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ out_of_office; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./components/marketingSite/outOfOffice/OutOfOfficeComponent.styled.tsx
var OutOfOfficeComponent_styled = __webpack_require__(96088);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/archive/OutOfOfficeArchive.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        " {\n    font-family: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.5;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  > div {\n    max-width: 25rem;\n    margin: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 90%);\n  background-color: var(--out-of-office-yellow);\n\n  img {\n    display: block;\n    opacity: 0.25;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  background-color: var(--out-of-office-blue);\n  clip-path: polygon(0 0%, 100% 15%, 100% 100%, 0% 85%);\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  margin-top: -",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  color: ",
        ";\n  text-align: left;\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n\n  a {\n    color: inherit;\n    transition: 0.3s;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.333;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d75fb7ae-0"
})(_templateObject(), Typography_styled/* Heading2 */.XJ, (0,theme/* fontFamily */.I8)("sans"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"));
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d75fb7ae-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"));
var StyledItemImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d75fb7ae-2"
})(_templateObject2());
var StyledItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d75fb7ae-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledItemDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d75fb7ae-4"
})(_templateObject4(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("navy_300"));

;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/archive/OutOfOfficeArchive.tsx






var OutOfOfficeArchive = function() {
    var t = (0,useI18n/* useI18n */.Q)("out-of-office").t;
    var archiveItems = [
        {
            title: t("out-of-office.archive.issue1.title"),
            date: t("out-of-office.archive.issue1.date"),
            url: "https://none.clickacm.com/show/qgJ2lZXPBBizIfJi3pmS/",
            image: (0,paths/* getPublicPath */.A)("/images/outOfOffice/issue1.jpg")
        },
        {
            title: t("out-of-office.archive.issue2.title"),
            date: t("out-of-office.archive.issue2.date"),
            url: "https://none.clickacm.com/show/b1615334-31d5-11ee-8de4-005056bd5094/",
            image: (0,paths/* getPublicPath */.A)("/images/outOfOffice/issue2.jpg")
        },
        {
            title: t("out-of-office.archive.issue3.title"),
            date: t("out-of-office.archive.issue3.date"),
            url: "https://none.clickacm.com/show/wu6deAtfPCX9motAD1CNjCqWmkkfoGdPylR2qmODcVrN426OfAqJlcaDTAw/",
            image: (0,paths/* getPublicPath */.A)("/images/outOfOffice/issue3.jpg")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                children: t("out-of-office.archive.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "out-of-office",
                i18nKey: "out-of-office.archive.desc"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                children: archiveItems.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.image,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: item.url,
                                        target: "_blank",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemDate, {
                                        children: item.date
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var archive_OutOfOfficeArchive = (OutOfOfficeArchive);

// EXTERNAL MODULE: ./components/marketingSite/outOfOffice/sections/footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(91153);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./utils/api.ts
var api = __webpack_require__(3818);
// EXTERNAL MODULE: ./utils/fetch.ts
var fetch = __webpack_require__(89608);
;// CONCATENATED MODULE: ./services/out-of-office.service.ts




var OutOfOfficeService = {
    join: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                url = (0,api/* getApiPathUrl */.P)("/v2/public/ui/newsletters/out-of-office");
                return [
                    2,
                    fetch/* post */.v_(url, data)
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var out_of_office_service = (OutOfOfficeService);

// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ./components/shared/FormGroup.styled.ts
var FormGroup_styled = __webpack_require__(17975);
;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/form/OutOfOfficeForm.styled.tsx

function OutOfOfficeForm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--out-of-office-blue);\n  display: flex;\n  flex-direction: column;\n  clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 95%);\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 90%);\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  img {\n    max-width: 15.5rem;\n    flex-shrink: 0;\n  }\n\n  ",
        " {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.3;\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.5;\n    margin: 0;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.6;\n    }\n  }\n"
    ]);
    OutOfOfficeForm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OutOfOfficeForm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-end;\n  }\n\n  button {\n    height: 3.5rem;\n  }\n\n  ",
        " {\n    @media (min-width: ",
        ") {\n      position: absolute;\n    }\n  }\n"
    ]);
    OutOfOfficeForm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var OutOfOfficeForm_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24d68e31-0"
})(OutOfOfficeForm_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl6"), Typography_styled/* Heading4 */.k8, (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-24d68e31-1"
})(OutOfOfficeForm_styled_templateObject1(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("md"), FormGroup_styled/* StyledFormGroupError */.jN, (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/form/OutOfOfficeForm.tsx






















var FormFieldsSchema = lib.z.object({
    email: lib.z.string().email("common:invalid-email")
});
var OutOfOfficeForm = function() {
    var t = (0,useI18n/* useI18n */.Q)("out-of-office").t;
    var router = (0,next_router.useRouter)();
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: ""
        },
        resolver: (0,zod/* zodResolver */.F)(FormFieldsSchema)
    });
    var handleSubmit = formMethods.handleSubmit;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            out_of_office_service.join({
                                email: data.email
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            router.push((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.outOfOfficeOk */.uu.outOfOfficeOk, router.locale))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("[OutOfOfficeForm] Could not send join to Out Of Office form. ".concat(error));
                        addErrorToast(t("out-of-office.form.submit-error", {
                            error: (0,errors/* getErrorMessage */.e)(error)
                        }), t("out-of-office.form.submit-error-title"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeForm_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,paths/* getPublicPath */.A)("/images/outOfOffice/form.png"),
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                        children: t("out-of-office.form.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "out-of-office",
                        i18nKey: "out-of-office.form.desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledForm, {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                    name: "email",
                                    formGroup: {
                                        label: t("out-of-office.form.email")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                    schema: "brand2",
                                    label: t("out-of-office.form.submit"),
                                    startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                    type: "submit",
                                    onClick: function() {
                                        return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("out-of-office-subscribed");
                                    }
                                })
                            ]
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var form_OutOfOfficeForm = (OutOfOfficeForm);

// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./components/marketingSite/outOfOffice/sections/header/OutOfOfficeHeader.styled.tsx
var OutOfOfficeHeader_styled = __webpack_require__(90504);
;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/header/OutOfOfficeHeader.tsx







var OutOfOfficeHeader = function() {
    var t = (0,useI18n/* useI18n */.Q)("out-of-office").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeHeader_styled/* StyledHeader */.eb, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeHeader_styled/* StyledLogo */.ps, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/outOfOffice/out-of-office.png"),
                        alt: "Out of office"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeHeader_styled/* StyledLogoManfred */.UO, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("out-of-office.header.offered-by")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: logos/* LOGO_MANFRED */.$q,
                                alt: "Manfred by Sngular"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                children: t("out-of-office.header.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "out-of-office",
                i18nKey: "out-of-office.header.desc"
            })
        ]
    });
};
/* harmony default export */ var header_OutOfOfficeHeader = (OutOfOfficeHeader);

;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/OutOfOfficeComponent.tsx








var OutOfOfficeComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("out-of-office").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfOfficeComponent_styled/* GlobalStyles */.nz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeComponent_styled/* StyledPage */.Ft, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/outOfOffice/banner.svg"),
                        alt: t("out-of-office.header.banner"),
                        className: "desktop"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/outOfOffice/banner_mobile.svg"),
                        alt: t("out-of-office.header.banner"),
                        className: "mobile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfOfficeComponent_styled/* StyledContainer */.PQ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_OutOfOfficeHeader, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_OutOfOfficeForm, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(archive_OutOfOfficeArchive, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var outOfOffice_OutOfOfficeComponent = (OutOfOfficeComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/out-of-office.tsx








var OutOfOfficePage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("out-of-office").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("out-of-office.page_title"),
                url: app_urls/* APP_URLS.outOfOffice */.uu.outOfOffice,
                desc: t("out-of-office.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_out_of_office.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "outOfOfficeLd",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '\n        {\n  "@context": "https://schema.org",\n  "@type": "Newsletter",\n  "name": "'.concat(t("out-of-office.page_title"), '",\n  "url": "https://www.getmanfred.com/out-of-office",\n  "description": "').concat(t("out-of-office.page_description"), '",\n  "publisher": {\n    "@type": "Organization",\n    "name": "Manfred",\n    "url": "https://www.getmanfred.com",\n    "logo": {\n      "@type": "ImageObject",\n      "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n    }\n  },\n  "audience": {\n    "@type": "BusinessAudience",\n    "name": "Empresas tecnol\xf3gicas"\n  },\n  "mainEntityOfPage": "https://www.getmanfred.com/out-of-office"\n}\n        ')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(outOfOffice_OutOfOfficeComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var out_of_office = (OutOfOfficePage);


/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ f; },
/* harmony export */   "M": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&t(e,f);var o={};for(var a in e){var n=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(f.fields,a);(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8)(o,a,Object.assign(e[a]||{},{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map


/***/ }),

/***/ 33161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
/* harmony import */ var _hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57982);
var n=function(e,o){for(var n={};e.length;){var t=e[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(r){return r.errors.forEach(function(r){return e.push(r)})}),o){var c=n[a].types,f=c&&c[t.code];n[a]=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .appendErrors */ .KN)(a,o,n,s,f?[].concat(f,t.message):t.message)}e.shift()}return n},t=function(r,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(o,n){try{var a=Promise.resolve(r["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(r){return u.shouldUseNativeValidation&&(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .validateFieldsNatively */ .M)({},u),{errors:{},values:s.raw?i:r}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return null!=r.errors}(r))return{values:{},errors:(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .toNestError */ .D)(n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3955,9775,9774,2888,179], function() { return __webpack_exec__(90514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);